module.exports = __webpack_public_path__ + "static/media/gift.b3161e5b.svg";